import { Icon } from "@chakra-ui/react";

const RedisIcon = (props) => (
  <Icon viewBox="0 0 52 52" {...props} fill="#A41E11">
    <g clipPath="url(#clip0_181_26931)">
      <path
        d="M49.9618 38.0816C47.1868 39.5291 32.8129 45.4389 29.7525 47.0338C26.6922 48.6288 24.9925 48.6136 22.5745 47.4584C20.1566 46.3032 4.86039 40.1246 2.10332 38.8067C0.724792 38.1478 0.00244141 37.5936 0.00244141 37.0698V31.8135C0.00244141 31.8135 19.9181 27.478 23.1342 26.3241C26.3503 25.1703 27.4628 25.129 30.2005 26.1311C32.9383 27.1333 49.2973 30.0848 52.0006 31.0759V36.2592C52.0006 36.7789 51.3775 37.362 49.9645 38.0844L49.9618 38.0816Z"
        fill="#A41E11"
      />
      <path
        d="M49.9619 32.8239C47.1869 34.2714 32.813 40.1812 29.7526 41.7761C26.6923 43.3711 24.9925 43.3559 22.5746 42.2007C20.1567 41.0455 4.86047 34.8669 2.10341 33.549C-0.653652 32.2312 -0.708794 31.3255 1.99726 30.2654L23.1329 22.0824C26.3476 20.93 27.4615 20.8872 30.1993 21.8894C32.937 22.8916 47.2241 28.5781 49.926 29.5844C52.628 30.5907 52.7341 31.3903 49.9591 32.8377L49.9619 32.8239Z"
        fill="#D82C20"
      />
      <path
        d="M49.9618 29.5099C47.1868 30.9574 32.8129 36.8671 29.7525 38.4621C26.6922 40.0571 24.9925 40.0419 22.5745 38.8867C20.1566 37.7315 4.86039 31.5529 2.10332 30.235C0.724792 29.5761 0.00244141 29.0219 0.00244141 28.4981V23.2417C0.00244141 23.2417 19.9181 18.9063 23.1342 17.7524C26.3503 16.5986 27.4628 16.5572 30.2005 17.5594C32.9383 18.5616 49.2973 21.5131 52.0006 22.5042V27.6875C52.0006 28.2072 51.3775 28.7903 49.9645 29.5127L49.9618 29.5099Z"
        fill="#A41E11"
      />
      <path
        d="M49.9619 24.2536C47.1869 25.701 32.813 31.6108 29.7526 33.2058C26.6923 34.8007 24.9925 34.7856 22.5746 33.6304C20.1567 32.4751 4.86047 26.2966 2.10341 24.9787C-0.653652 23.6608 -0.708794 22.7551 1.99726 21.695L23.1329 13.5134C26.3476 12.3596 27.4615 12.3183 30.1993 13.3204C32.937 14.3226 47.2241 20.0105 49.9288 20.9989C52.6335 21.9873 52.7369 22.8047 49.9619 24.2522V24.2536Z"
        fill="#D82C20"
      />
      <path
        d="M49.9618 20.6212C47.1868 22.0686 32.8129 27.9784 29.7525 29.5747C26.6922 31.1711 24.9925 31.1545 22.5745 29.9993C20.1566 28.8441 4.86039 22.6655 2.10332 21.3476C0.724792 20.6887 0.00244141 20.1345 0.00244141 19.6107V14.3516C0.00244141 14.3516 19.9181 10.0161 23.1342 8.86229C26.3503 7.70846 27.4628 7.6671 30.2005 8.6693C32.9383 9.67149 49.2973 12.6229 52.0006 13.6141V18.7974C52.0006 19.3171 51.3775 19.9002 49.9645 20.6225L49.9618 20.6212Z"
        fill="#A41E11"
      />
      <path
        d="M49.9619 15.3634C47.1869 16.8109 32.813 22.7207 29.7526 24.3156C26.6923 25.9106 24.9925 25.8954 22.5746 24.7402C20.1567 23.585 4.86047 17.4064 2.10341 16.0886C-0.653652 14.7707 -0.708794 13.865 1.99726 12.8049L23.1329 4.62331C26.3476 3.46948 27.4615 3.42812 30.1993 4.43031C32.937 5.43251 47.2241 11.1203 49.9288 12.1087C52.6335 13.0971 52.7369 13.9146 49.9619 15.3621V15.3634Z"
        fill="#D82C20"
      />
      <path
        d="M27.2989 13.1964L25.6694 10.4876L20.4669 10.0189L24.3488 8.61828L23.1839 6.46777L26.8178 7.88766L30.2448 6.76554L29.3184 8.98773L32.8116 10.2973L28.3066 10.766L27.2989 13.1964ZM18.6196 18.5892L30.668 16.7392L27.0287 22.0769L18.6196 18.5892Z"
        fill="white"
      />
      <path
        d="M15.3719 16.6441C18.9289 16.6441 21.8124 15.5264 21.8124 14.1476C21.8124 12.7688 18.9289 11.6511 15.3719 11.6511C11.8149 11.6511 8.9314 12.7688 8.9314 14.1476C8.9314 15.5264 11.8149 16.6441 15.3719 16.6441Z"
        fill="white"
      />
      <path
        d="M45.2692 13.7837L38.1422 16.5986L38.1367 10.9646L45.2692 13.7837Z"
        fill="#7A0C00"
      />
      <path
        d="M38.1437 16.5986L37.3717 16.9019L30.2502 14.0869L38.1396 10.9659L38.1437 16.5986Z"
        fill="#AD2115"
      />
    </g>
    <defs>
      <clipPath id="clip0_181_26931">
        <rect width="52" height="52" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default RedisIcon;
